import { Pipe, PipeTransform } from "@angular/core";
import { DriverLicenseClass } from "src/app/model/driver.model";
import { DispatchService } from "src/app/services/dispatch.service";

@Pipe({
  name: 'driverLicense'
})
export class DriverLicensePipe implements PipeTransform {
  public constructor(private service: DispatchService) { }
  
  public transform(value: DriverLicenseClass | DriverLicenseClass[]) {
    const licenses = value instanceof Array
      ? value
      : [value];

    return licenses.reduce((names, licenseId, index) => {
      const [name] = Object.entries(this.service.driverLicenceClasses)
        .find(([_, value]) => value === licenseId);

      if(index === 0) {
        return name;
      }
      else if(index + 1 === self.length) {
        return `${names} and ${name}`;
      }
      else {
        return `${names}, ${name}`;
      }
    }, '');
  }
}
